export default __webpack_public_path__ + "static/media/work2.a5a9b7da.png";